/**
* ResourceImageFormat
* Формат изображения<br>
* 
* - `png` PNG
* 
* Изображение в формате PNG
* - `jpeg` JPEG
* 
* Изображение в формате JPEG
* - `webp` WEBP
* 
* Изображение в формате WEBP
* - `tiff` TIFF
* 
* Изображение в формате TIFF
* 
*/
export enum ResourceImageFormat {
  PNG = 'png',
  JPEG = 'jpeg',
  WEBP = 'webp',
  TIFF = 'tiff',
}


/**
* PromotionRewardType
* словарь значений публикуется под именем `Domain.Entities.Promotions.PromotionRewardType`
* 
* Тип награды акции (дискриминатор TPH).
* 
* - `PercentDiscount` Процентная скидка
* 
* Процентная скидка на выбранную область корзины.
* - `FixedAmountDiscount` Фиксированная скидка
* 
* Фиксированная сумма скидки.
* - `FixedPrice` Фиксированная цена
* 
* Товар по фиксированной цене за единицу.
* - `FreeShipping` Бесплатная доставка
* 
* Скидка на стоимость доставки.
* - `NPlusM` N+M
* 
* Акция N+M: часть единиц бесплатно при покупке набора.
* - `Bundle` Комплект
* 
* Комплект товаров по фиксированной цене.
* - `Gift` Подарок
* 
* Бесплатные единицы подарочного товара в корзине.
* - `PercentCashback` Процентный кэшбэк
* 
* Процентный кэшбэк бонусами (не снижает цену).
* - `FixedAmountCashback` Фиксированный кэшбэк
* 
* Фиксированный кэшбэк бонусами (не снижает цену).
* - `PointsMultiplier` Множитель баллов
* 
* Множитель базового начисления баллов лояльности.
* 
*/
export enum PromotionRewardType {
  PERCENTDISCOUNT = 'PercentDiscount',
  FIXEDAMOUNTDISCOUNT = 'FixedAmountDiscount',
  FIXEDPRICE = 'FixedPrice',
  FREESHIPPING = 'FreeShipping',
  NPLUSM = 'NPlusM',
  BUNDLE = 'Bundle',
  GIFT = 'Gift',
  PERCENTCASHBACK = 'PercentCashback',
  FIXEDAMOUNTCASHBACK = 'FixedAmountCashback',
  POINTSMULTIPLIER = 'PointsMultiplier',
}


/**
* AttributeRequirementsStringType
* 
*/
export enum AttributeRequirementsStringType {
  STRING = 'String',
}


/**
* AttributeRequirementsBoolType
* 
*/
export enum AttributeRequirementsBoolType {
  BOOL = 'Bool',
}


/**
* AttributeRequirementsIntegerType
* 
*/
export enum AttributeRequirementsIntegerType {
  INTEGER = 'Integer',
}


/**
* AttributeRequirementsDecimalType
* 
*/
export enum AttributeRequirementsDecimalType {
  DECIMAL = 'Decimal',
}


/**
* AttributeRequirementsDictType
* 
*/
export enum AttributeRequirementsDictType {
  DICT = 'Dict',
}


/**
* AttributeRequirementsFileType
* 
*/
export enum AttributeRequirementsFileType {
  FILE = 'File',
}


/**
* SDEKOfficeType
* словарь значений публикуется под именем `Infrastructure.SDEK.Dto.Enums.SDEKOfficeType`
* 
* Тип офиса
* 
* - `Postamat` Постамат
* - `Pvz` ПВЗ
* 
*/
export enum SDEKOfficeType {
  POSTAMAT = 'Postamat',
  PVZ = 'Pvz',
}


/**
* SDEKLang
* Язык вывода информации.
* 
* - `Rus` Rus
* - `Eng` Eng
* - `Zho` Zho
* 
*/
export enum SDEKLang {
  RUS = 'Rus',
  ENG = 'Eng',
  ZHO = 'Zho',
}


/**
* CdekCounterpartyType
* Тип контрагента<br>
*/
export enum CdekCounterpartyType {
  INDIVIDUAL = 'Individual',
  LEGALENTITY = 'LegalEntity',
}


/**
* ContentType
* словарь значений публикуется под именем `ContentType`
* 
* Тип контента
* 
* - `Page` Страница
* 
* Статическая страница («Доставка и оплата», положения)
* - `News` Новость
* 
* Новость (лента с датой публикации)
* - `Article` Статья
* 
* Статья блога (витрина — Phase 1)
* - `Instruction` Инструкция
* 
* Инструкция (обычно с приложенными документами)
* 
*/
export enum ContentType {
  PAGE = 'Page',
  NEWS = 'News',
  ARTICLE = 'Article',
  INSTRUCTION = 'Instruction',
}


/**
* SortDirection
* Направление сортировки
* 
* - `asc` По возрастанию
* - `desc` По убыванию
* 
*/
export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}


/**
* CursorMode
* Режим курсора
* 
* - `before` перед
* 
* В зависимости от сортировки (Web.Core.Pagination.SortDirection): <para />
* для Web.Core.Pagination.SortDirection.asc - меньше; <para />
* для Web.Core.Pagination.SortDirection.desc - больше; <para />
* - `after` после
* 
* В зависимости от сортировки (Web.Core.Pagination.SortDirection): <para />
* для Web.Core.Pagination.SortDirection.asc - больше; <para />
* для Web.Core.Pagination.SortDirection.desc - меньше; <para />
* - `from` начиная с
* 
* В зависимости от сортировки (Web.Core.Pagination.SortDirection): <para />
* для Web.Core.Pagination.SortDirection.asc - больше или равно; <para />
* для Web.Core.Pagination.SortDirection.desc - меньше или равно; <para />
* - `to` заканчивая
* 
* В зависимости от сортировки (Web.Core.Pagination.SortDirection): <para />
* для Web.Core.Pagination.SortDirection.asc - меньше или равно; <para />
* для Web.Core.Pagination.SortDirection.desc - больше или равно; <para />
* 
*/
export enum CursorMode {
  BEFORE = 'before',
  AFTER = 'after',
  FROM = 'from',
  TO = 'to',
}


/**
* ContentResourceType
* Тип файла-ресурса контента
* 
* - `Image` Изображение
* 
* Изображение (галерея)
* - `Document` Документ
* 
* Документ (PDF-инструкции и пр.)
* 
*/
export enum ContentResourceType {
  IMAGE = 'Image',
  DOCUMENT = 'Document',
}


/**
* LoyaltyLotKind
* словарь значений публикуется под именем `Domain.Entities.Loyalty.LoyaltyLotKind`
* 
* Тип bonus-лота (кэшбэк или промо).
* 
* - `Cashback` Кэшбэк
* - `Promo` Промо
* 
*/
export enum LoyaltyLotKind {
  CASHBACK = 'Cashback',
  PROMO = 'Promo',
}


/**
* LoyaltyTransactionType
* словарь значений публикуется под именем `Domain.Entities.Loyalty.LoyaltyTransactionType`
* 
* Тип записи в ledger кошелька лояльности.
* 
* - `CashbackAccrual` Начисление кэшбэка
* - `PromoAccrual` Начисление промо
* - `Redemption` Списание
* - `RedemptionHold` Холд списания
* - `RedemptionRelease` Снятие холда
* - `Expiration` Истечение
* - `StornoAccrual` Сторно начисления
* - `StornoPromoAccrual` Сторно promo-начисления
* - `ManualAdjustment` Ручная корректировка
* 
*/
export enum LoyaltyTransactionType {
  CASHBACKACCRUAL = 'CashbackAccrual',
  PROMOACCRUAL = 'PromoAccrual',
  REDEMPTION = 'Redemption',
  REDEMPTIONHOLD = 'RedemptionHold',
  REDEMPTIONRELEASE = 'RedemptionRelease',
  EXPIRATION = 'Expiration',
  STORNOACCRUAL = 'StornoAccrual',
  STORNOPROMOACCRUAL = 'StornoPromoAccrual',
  MANUALADJUSTMENT = 'ManualAdjustment',
}


/**
* Notificationtype
* словарь значений публикуется под именем `Domain.Entities.Notifications.NotificationType`
* 
* Тип уведомления
* 
* - `Order` Заказы
* 
* Уведомление о заказе
* - `Product` Товары
* 
* Уведомление о товаре
* - `ImageGeneration` AI-изображения
* 
* Уведомление о генерации изображений
* - `CrmBroadcast` CRM-рассылки
* 
* Рассылка по сегменту CRM (US-14)
* - `Exchange` Обмен данными
* 
* Проблемы обмена с внешними системами (RFC-006, US-13)
* 
*/
export enum Notificationtype {
  ORDER = 'Order',
  PRODUCT = 'Product',
  IMAGEGENERATION = 'ImageGeneration',
  CRMBROADCAST = 'CrmBroadcast',
  EXCHANGE = 'Exchange',
}


/**
* NotificationType
* словарь значений публикуется под именем `Domain.Entities.Notifications.NotificationType`
* 
* Тип уведомления<br>
* 
* - `Order` Заказы
* 
* Уведомление о заказе
* - `Product` Товары
* 
* Уведомление о товаре
* - `ImageGeneration` AI-изображения
* 
* Уведомление о генерации изображений
* - `CrmBroadcast` CRM-рассылки
* 
* Рассылка по сегменту CRM (US-14)
* - `Exchange` Обмен данными
* 
* Проблемы обмена с внешними системами (RFC-006, US-13)
* 
*/
export enum NotificationType {
  ORDER = 'Order',
  PRODUCT = 'Product',
  IMAGEGENERATION = 'ImageGeneration',
  CRMBROADCAST = 'CrmBroadcast',
  EXCHANGE = 'Exchange',
}


/**
* Orderstatuspublic
* словарь значений публикуется под именем `Domain.Entities.Orders.OrderStatusPublic`
* 
* Статусы заказа (для покупателя)
* 
* - `Calculated` Ожидает оплаты
* 
* Ожидает оплаты
* - `Payment` В процессе оплаты
* 
* В процессе оплаты
* - `Collection` Собирается
* 
* В процессе сбора
* - `Delivery` В процессе доставки
* 
* В процессе доставки
* - `Receiving` Ожидает получения
* 
* Ожидает получения
* - `Cancelling` В процессе отмены
* 
* В процессе отмены
* - `Completing` В процессе завершения
* 
* В процессе завершения
* - `Cancelled` Отменён
* 
* Отменён
* - `Completed` Завершён
* 
* Завершён
* 
*/
export enum Orderstatuspublic {
  CALCULATED = 'Calculated',
  PAYMENT = 'Payment',
  COLLECTION = 'Collection',
  DELIVERY = 'Delivery',
  RECEIVING = 'Receiving',
  CANCELLING = 'Cancelling',
  COMPLETING = 'Completing',
  CANCELLED = 'Cancelled',
  COMPLETED = 'Completed',
}


/**
* OrderStatusPublic
* словарь значений публикуется под именем `Domain.Entities.Orders.OrderStatusPublic`
* 
* Значение статуса<br>
* 
* - `Calculated` Ожидает оплаты
* 
* Ожидает оплаты
* - `Payment` В процессе оплаты
* 
* В процессе оплаты
* - `Collection` Собирается
* 
* В процессе сбора
* - `Delivery` В процессе доставки
* 
* В процессе доставки
* - `Receiving` Ожидает получения
* 
* Ожидает получения
* - `Cancelling` В процессе отмены
* 
* В процессе отмены
* - `Completing` В процессе завершения
* 
* В процессе завершения
* - `Cancelled` Отменён
* 
* Отменён
* - `Completed` Завершён
* 
* Завершён
* 
*/
export enum OrderStatusPublic {
  CALCULATED = 'Calculated',
  PAYMENT = 'Payment',
  COLLECTION = 'Collection',
  DELIVERY = 'Delivery',
  RECEIVING = 'Receiving',
  CANCELLING = 'Cancelling',
  COMPLETING = 'Completing',
  CANCELLED = 'Cancelled',
  COMPLETED = 'Completed',
}


/**
* OrderCancelledReason
* Известная причина отмены заказа<br>
*/
export enum OrderCancelledReason {
  NOTPAID = 'NotPaid',
  CUSTOMERMANUAL = 'CustomerManual',
  PAYMENTCANCELLED = 'PaymentCancelled',
  BADDATA = 'BadData',
  NOTDELIVERED = 'NotDelivered',
}


/**
* DeliveryMethodKind
* словарь значений публикуется под именем `Domain.Entities.Channels.DeliveryMethodKind`
* 
* Вид способа доставки.
* 
* - `Cdek` СДЭК
* 
* Интеграция СДЭК (не более одной записи на канал).
* - `Pickup` Самовывоз
* 
* Самовывоз со склада (не более одной записи на канал).
* - `Manual` Без интеграции
* 
* Способ без интеграции API (может быть несколько на канал).
* 
*/
export enum DeliveryMethodKind {
  CDEK = 'Cdek',
  PICKUP = 'Pickup',
  MANUAL = 'Manual',
}


/**
* OrderDeliveryMethodCdekDtoKind
* 
*/
export enum OrderDeliveryMethodCdekDtoKind {
  CDEK = 'Cdek',
}


/**
* OrderDeliveryMethodPickupDtoKind
* 
*/
export enum OrderDeliveryMethodPickupDtoKind {
  PICKUP = 'Pickup',
}


/**
* DayOfWeek
* День недели.
* 
* - `Sunday` Sunday
* - `Monday` Monday
* - `Tuesday` Tuesday
* - `Wednesday` Wednesday
* - `Thursday` Thursday
* - `Friday` Friday
* - `Saturday` Saturday
* 
*/
export enum DayOfWeek {
  SUNDAY = 'Sunday',
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
}


/**
* OrderDeliveryMethodManualDtoKind
* 
*/
export enum OrderDeliveryMethodManualDtoKind {
  MANUAL = 'Manual',
}


/**
* AttributeRequirementsType
* словарь значений публикуется под именем `AttributeRequirementsType`
* 
* Тип значения атрибута<br>
* 
* - `String` Строка
* 
* Строковый атрибут
* - `Bool` Логический
* 
* Логический атрибут
* - `Integer` Целое число
* 
* Атрибут со значением в виде целого числа
* - `Decimal` Десятичное число
* 
* Атрибут со значением в виде десятичного числа
* - `Dict` Справочник
* 
* Атрибут со значением из справочника
* - `File` Файл
* 
* Атрибут со ссылкой на файл
* 
*/
export enum AttributeRequirementsType {
  STRING = 'String',
  BOOL = 'Bool',
  INTEGER = 'Integer',
  DECIMAL = 'Decimal',
  DICT = 'Dict',
  FILE = 'File',
}


/**
* OrderItemStatus
* словарь значений публикуется под именем `Domain.Entities.Orders.OrderItemStatus`
* 
* Значение статуса<br>
* 
* - `Calculated` Ожидает оплаты
* 
* Ожидает оплаты
* - `Payment` В процессе оплаты
* 
* В процессе оплаты
* - `Collection` Собирается
* 
* В процессе сбора
* - `Delivery` В процессе доставки
* 
* В процессе доставки
* - `Receiving` Ожидает получения
* 
* Ожидает получения
* - `Completing` Ожидает завершения
* 
* В процессе ожидания завершения
* - `Cancelled` Отменён
* 
* Отменён
* - `Completed` Завершён
* 
* Завершён
* 
*/
export enum OrderItemStatus {
  CALCULATED = 'Calculated',
  PAYMENT = 'Payment',
  COLLECTION = 'Collection',
  DELIVERY = 'Delivery',
  RECEIVING = 'Receiving',
  COMPLETING = 'Completing',
  CANCELLED = 'Cancelled',
  COMPLETED = 'Completed',
}


/**
* OrderItemCancelledReason
* Известная причина отмены позиции заказа<br>
*/
export enum OrderItemCancelledReason {
  NOTPAID = 'NotPaid',
  REFUND = 'Refund',
  CUSTOMERMANUAL = 'CustomerManual',
  PAYMENTCANCELLED = 'PaymentCancelled',
  BADDATA = 'BadData',
  NOTDELIVERED = 'NotDelivered',
}


/**
* PaymentMoment
* словарь значений публикуется под именем `Domain.Entities.Channels.PaymentMoment`
* 
* Момент оплаты по данным реестра методов шлюза
* 
* - `Prepayment` Предоплата
* 
* Предоплата при оформлении заказа.
* - `OnReceipt` При получении
* 
* Оплата при получении заказа.
* 
*/
export enum PaymentMoment {
  PREPAYMENT = 'Prepayment',
  ONRECEIPT = 'OnReceipt',
}


/**
* PaymentAcquirer
* словарь значений публикуется под именем `Domain.Entities.Channels.PaymentAcquirer`
* 
* Кто принимает деньги (по данным реестра методов шлюза)
* 
* - `Gateway` Платёжный шлюз
* 
* Платёжный шлюз, подключённый у продавца (сейчас — T-Bank).
* - `Seller` Продавец на месте
* 
* Продавец на месте: касса магазина или склада.
* - `Carrier` Служба доставки
* 
* Служба доставки (наложенный платёж).
* 
*/
export enum PaymentAcquirer {
  GATEWAY = 'Gateway',
  SELLER = 'Seller',
  CARRIER = 'Carrier',
}


/**
* Deliverymethodkind
* словарь значений публикуется под именем `Domain.Entities.Channels.DeliveryMethodKind`
* 
* Вид способа доставки в каталоге канала / на заказе.
* 
* - `Cdek` СДЭК
* 
* Интеграция СДЭК (не более одной записи на канал).
* - `Pickup` Самовывоз
* 
* Самовывоз со склада (не более одной записи на канал).
* - `Manual` Без интеграции
* 
* Способ без интеграции API (может быть несколько на канал).
* 
*/
export enum Deliverymethodkind {
  CDEK = 'Cdek',
  PICKUP = 'Pickup',
  MANUAL = 'Manual',
}


/**
* ShowcasePageBlockCarouselDtoType
* 
*/
export enum ShowcasePageBlockCarouselDtoType {
  CAROUSEL = 'Carousel',
}


/**
* PageBlockTextAlignment
* словарь значений публикуется под именем `Domain.Entities.PageBlocks.PageBlockTextAlignment`
* 
* Выравнивание текстового блока.
* 
* - `Left` Слева
* - `Center` По центру
* - `Right` Справа
* 
*/
export enum PageBlockTextAlignment {
  LEFT = 'Left',
  CENTER = 'Center',
  RIGHT = 'Right',
}


/**
* PageBlockCtaTargetType
* словарь значений публикуется под именем `Domain.Entities.PageBlocks.PageBlockCtaTargetType`
* 
* Тип цели перехода.
* 
* - `Catalog` Каталог
* - `Category` Категория
* - `ProductCollection` Подборка
* - `ContentPage` CMS-страница
* - `ExternalUrl` Внешняя ссылка
* 
*/
export enum PageBlockCtaTargetType {
  CATALOG = 'Catalog',
  CATEGORY = 'Category',
  PRODUCTCOLLECTION = 'ProductCollection',
  CONTENTPAGE = 'ContentPage',
  EXTERNALURL = 'ExternalUrl',
}


/**
* ShowcasePageBlockProductCollectionDtoType
* 
*/
export enum ShowcasePageBlockProductCollectionDtoType {
  PRODUCTCOLLECTION = 'ProductCollection',
}


/**
* ImageResizeMode
* Режим, как изображение должно изменять размеры
* 
* - `Crop` Crop
* - `Pad` Pad
* - `BoxPad` BoxPad
* - `Max` Max
* - `Min` Min
* - `Stretch` Stretch
* 
*/
export enum ImageResizeMode {
  CROP = 'Crop',
  PAD = 'Pad',
  BOXPAD = 'BoxPad',
  MAX = 'Max',
  MIN = 'Min',
  STRETCH = 'Stretch',
}


/**
* ImageResizeAnchorPosition
* 
* 
* - `Center` Center
* - `Top` Top
* - `Bottom` Bottom
* - `Left` Left
* - `Right` Right
* - `TopLeft` TopLeft
* - `TopRight` TopRight
* - `BottomRight` BottomRight
* - `BottomLeft` BottomLeft
* 
*/
export enum ImageResizeAnchorPosition {
  CENTER = 'Center',
  TOP = 'Top',
  BOTTOM = 'Bottom',
  LEFT = 'Left',
  RIGHT = 'Right',
  TOPLEFT = 'TopLeft',
  TOPRIGHT = 'TopRight',
  BOTTOMRIGHT = 'BottomRight',
  BOTTOMLEFT = 'BottomLeft',
}


/**
* ReviewStatus
* словарь значений публикуется под именем `Domain.Entities.Reviews.ReviewStatus`
* 
* Статус модерации.
* 
* - `Pending` На проверке
* 
* Ожидает модерации.
* - `Published` Опубликован
* 
* Опубликован.
* - `Rejected` Отклонён
* 
* Отклонён или скрыт модератором.
* 
*/
export enum ReviewStatus {
  PENDING = 'Pending',
  PUBLISHED = 'Published',
  REJECTED = 'Rejected',
}


/**
* ReviewRejectReason
* Причина отклонения.
*/
export enum ReviewRejectReason {
  SPAM = 'Spam',
  NOTABOUTPRODUCT = 'NotAboutProduct',
  OFFENSIVE = 'Offensive',
  PERSONALDATA = 'PersonalData',
  OTHER = 'Other',
}


/**
* RobotsPolicy
* словарь значений публикуется под именем `RobotsPolicy`
* 
* Политика индексации витрины: закрывает витрину целиком через robots.txt<br>
* 
* - `Indexable` Индексируется
* 
* Витрина открыта для индексации (некоммерческие разделы закрыты точечно)
* - `NoindexAll` Закрыта от индексации
* 
* Витрина закрыта от индексации целиком (`Disallow: /`) — для тестовых стендов
* 
*/
export enum RobotsPolicy {
  INDEXABLE = 'Indexable',
  NOINDEXALL = 'NoindexAll',
}


/**
* Gender
* Пол<br>
*/
export enum Gender {
  MALE = 'Male',
  FEMALE = 'Female',
}
